export const FEATURE_FLAGS = {
  AGENT_MANAGEMENT: 'agent_management',
  CRM: 'crm',
  INBOX_MANAGEMENT: 'inbox_management',
  LABELS: 'labels',
  HOTEL_DATA: 'help_center',
  MOBILE_WEB: 'mobile_web',
  DICTATION: 'dictation',
  VOICE_RECORDER: 'voice_recorder',
  HALLOWEEN: 'halloween',
};
